import { defineMessages } from '@jutro/locale';

export default defineMessages({
    yourHome: {
        id: 'quoteandbind.pa.wizard.step.Drivers',
        defaultMessage: 'Drivers'
    },
    construction: {
        id: 'quoteandbind.pa.wizard.step.Vehicles',
        defaultMessage: 'Vehicles'
    },
    getYourQuoteFaster: {
        id: 'quoteandbind.views.contact-details.Get your quote faster!',
        defaultMessage: 'Get your quote faster!',
    },
    scanDriverLicenseDescription: {
        id: 'quoteandbind.views.contact-details.Scan your driver license barcode to automatically enter the necessary information.',
        defaultMessage: 'Scan your driver license barcode to automatically enter the necessary information.',
    },
    scanDriverLicenseBarcode: {
        id: 'platform.documentupload.templates.document-upload.Scan driver license barcode',
        defaultMessage: 'Scan driver license barcode',
    },
    scanDriverLicenseBarcodeAutomaticallyEnterDetails: {
        id: 'quoteandbind.views.contact-details.Scan your driver license barcode to automatically enter the necessary information.',
        defaultMessage: 'Scan your driver license barcode to automatically enter the necessary information.',
    },
    mlYourInfoHeader: {
        id: 'ml.quoteandbind.pa.wizard.step.YourInfo.header',
        defaultMessage: 'Tell us about yourself'
    },
    mlDriverHeader: {
        id: 'ml.quoteandbind.pa.wizard.step.Drivers.header',
        defaultMessage: 'Tell us about your drivers'
    },
    mlVehiclesHeader: {
        id: 'ml.quoteandbind.pa.wizard.step.Vehicles.header',
        defaultMessage: 'Details about your vehicles'
    },
    mlPrefillHeader: {
        id: 'ml.quoteandbind.pa.wizard.step.Prefill.header',
        defaultMessage: 'Review your details to continue'
    },
    additionalInformation: {
        id: 'ml.quoteandbind.pa.wizard.step.Additional Info',
        defaultMessage: 'Additional Info'
    },
    mlAdditionalInformationHeader: {
        id: 'ml.quoteandbind.pa.wizard.step.Additional Information.header',
        defaultMessage: 'Here\'s what we found out about your current insurance'
    },
    mlQuoteHeader: {
        id: 'ml.quoteandbind.pa.wizard.step.Quote.header',
        defaultMessage: 'Your auto insurance quote'
    },
    mlAdjustmentsHeader: {
        id: 'ml.quoteandbind.pa.wizard.step.Adjustments.header',
        defaultMessage: 'Adjustments for your policy'
    },
    mlESignatureHeader: {
        id: 'ml.quoteandbind.pa.wizard.step.ESignature.header',
        defaultMessage: 'Sign below to complete your purchase'
    },
    mlHVQAddtlDriversHeader: {
        id: 'ml.quoteandbind.pa.wizard.step.HVQAdditionalDrivers.header',
        defaultMessage: 'We found these drivers associated with your household. Remove any that aren\'t yours.'
    }
});
